import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	gap: 10px;
	grid-gap: 10px;
	grid-template-rows: 40px 10px auto;

	hr {
		border: 1px solid #d8dee6;
		margin: 0 20px;
		height: 1px;
	}
`;
